const style1 = { 
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width: "100%",
    maxWidth: "437px" // 437px; 374px
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = { 
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = { 
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"135.92677% 0 0 0", // 135.92677% 0 0 0; 123.7968%
    width:"100%"
}
const style5 = { 
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
// function AdamsJohnEmbed(){
//     return (
//         <>
//         <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/471503400" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/471503400?et=SJSAeXgcRtRSOWTCVK6_PA&tld=com&sig=5t4jEfSwFHsC2HWbVrrefIgwCmhp65NtnRRRXttAFN8=&caption=true&ver=1" scrolling="no" frameBorder="0" width="374" height="463" style={style5}></iframe></div></div>
//         </>
//     );
// };
function AdamsJohnEmbed(){
        return (
            <>
            <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/3292953" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/3292953?et=yvOeeaeDRBdoxZwK2zYgYQ&tld=com&sig=PaLyGYOohfGibMFJcwgxwTk02dSP5pMQb3w-AEYsA7U=&caption=true&ver=1" title="John Adams" scrolling="no" frameBorder="0" width="437" height="594" style={style5}></iframe></div></div>
            </>
        );
};
export default AdamsJohnEmbed;